export const environment = {
  production: false,
  serverIP: 'https://bafl-devapi.lfdanalytics.com/',
};
